import { useEffect, useRef } from 'react';

export function useAutoRefresh(callback: () => void, intervalMs: number) {
  const cbRef = useRef(callback);
  cbRef.current = callback;
  const lastRunRef = useRef(0);

  useEffect(() => {
    const run = () => {
      lastRunRef.current = Date.now();
      cbRef.current();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible' && Date.now() - lastRunRef.current >= intervalMs) {
        run();
      }
    };

    const id = setInterval(() => {
      if (document.visibilityState === 'visible') run();
    }, intervalMs);

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [intervalMs]);
}
